export default function(category: string, action: string, label: string = '', value: string = '') {
    if (typeof window.dataLayer === 'undefined') {
        return; // GTM not loaded or blocked by privacy protection
    }
    window.dataLayer.push({
        'event': 'Fire Event',
        'category': category,
        'action': action,
        'label': label,
        'value': value,
    });
};
